'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _domAlign = require('dom-align');

var _domAlign2 = _interopRequireDefault(_domAlign);

var _data = require('../util/data');

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var PLACEMENTS = {
  points: ['tl', 'bl'],
  offset: [0, 2],
  overflow: {
    adjustX: 0,
    adjustY: 0
  }
};

/**
 * 定位弹窗位置
 */
var Trigger = (_temp = _class = function (_Component) {
  _inherits(Trigger, _Component);

  function Trigger(props) {
    _classCallCheck(this, Trigger);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Trigger).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      visible: props.visible || props.defaultVisible,
      alignCls: (props.align.points || []).join('_')
    };
    return _this;
  }

  _createClass(Trigger, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.componentDidUpdate({}, { visible: this.state.visible });
      window.addEventListener('resize', this.forceAlign, false);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_ref, _ref2) {
      var preAlign = _ref.align;
      var preWidth = _ref.equalTargetWidth;
      var preHeight = _ref.equalTargetHeight;
      var preTarget = _ref.target;
      var preVisible = _ref2.visible;
      var _props = this.props;
      var autoDestory = _props.autoDestory;
      var onAfterVisible = _props.onAfterVisible;
      var align = _props.align;
      var equalTargetWidth = _props.equalTargetWidth;
      var equalTargetHeight = _props.equalTargetHeight;
      var target = _props.target;
      var visible = this.state.visible;

      var self = this;
      if (!visible) {
        // 现在要隐藏
        if (autoDestory) {
          // 要移除dom
          this.removePopup();
        } else if (preVisible) {
          // 显示 => 不显示
          this.renderSubtreeComponent(function () {
            // 这里直接 invisible 样式控制不显示, 减少计算
            onAfterVisible(visible);
          });
        }
      } else {
        // 现在要显示
        this.renderSubtreeComponent(function () {
          var reAlign = false;
          // 不显示 => 显示, 显示 => 变化宽度, 显示 => 变化位置 >>>> 则去重新计算位置
          if (!preVisible || preWidth !== equalTargetWidth || preHeight !== equalTargetHeight || !_.isEqual(preAlign, align)) {
            reAlign = true;
          } else {
            // 显示 => 显示,也没有变化位置的请求
            var lastTarget = preTarget();
            var currentTarget = target();
            if ((0, _data.isWindow)(lastTarget) && (0, _data.isWindow)(currentTarget)) {
              reAlign = false;
            } else if (lastTarget !== currentTarget) {
              // 父节点不同 则去重新计算位置
              reAlign = true;
            }
          }
          if (reAlign) {
            self.forceAlign();
          }
          if (preVisible !== visible) {
            onAfterVisible(visible);
          }
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref3) {
      var visible = _ref3.visible;

      if (visible !== this.state.visible) {
        this.setState({
          visible: visible
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removePopup();
      window.removeEventListener('resize', this.forceAlign, false);
    }

    // 获取父DOM


    // 渲染内容至某DOM节点

  }, {
    key: 'renderContentComponent',

    // 渲染内容
    value: function renderContentComponent() {
      var _classnames;

      var _props2 = this.props;
      var prefixCls = _props2.prefixCls;
      var className = _props2.className;
      var children = _props2.children;
      var autoDestory = _props2.autoDestory;
      var align = _props2.align;
      var _state = this.state;
      var visible = _state.visible;
      var alignCls = _state.alignCls;

      if (!visible && autoDestory) {
        return null;
      }
      prefixCls += '-trigger';
      var cls = (0, _classnames3.default)((_classnames = {}, _defineProperty(_classnames, '' + className, className), _defineProperty(_classnames, '' + prefixCls, true), _defineProperty(_classnames, prefixCls + '-' + alignCls, alignCls), _defineProperty(_classnames, prefixCls + '-useCssBottom', align.useCssBottom), _defineProperty(_classnames, prefixCls + '-useCssRight', align.useCssRight), _defineProperty(_classnames, prefixCls + '-invisible', !visible), _classnames));

      return _react2.default.createElement(
        'div',
        { className: cls },
        children
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }

    /**
     * 移除弹出框
     */

    /**
     * 获得当前弹出的DOM
     */


    /**
     * 重新定位弹出的元素
     */

  }]);

  return Trigger;
}(_react.Component), _class.propTypes = {
  prefixCls: _propTypes2.default.string,
  popupClassName: _propTypes2.default.string,
  className: _propTypes2.default.string,
  visible: _propTypes2.default.bool,
  defaultVisible: _propTypes2.default.bool,
  equalTargetWidth: _propTypes2.default.bool,
  equalTargetHeight: _propTypes2.default.bool,
  align: _propTypes2.default.object,
  autoDestory: _propTypes2.default.bool,
  getPopupContainer: _propTypes2.default.func,
  target: _propTypes2.default.func,
  onAfterVisible: _propTypes2.default.func,
  onAlign: _propTypes2.default.func
}, _class.defaultProps = {
  prefixCls: 'mt',
  popupClassName: '',
  align: PLACEMENTS,
  visible: null, // 是否显示
  defaultVisible: false, // 是否显示
  equalTargetWidth: true, // 是否与参照节点等宽
  equalTargetHeight: false, // 是否与参照节点等高
  autoDestory: false, // 是否自动销毁, 如果设置为 true, 不显示或者卸载时销毁
  getPopupContainer: null, // 弹出到的父节点, 返回一个 DOM 节点
  target: function target() {
    return document.body;
  },
  // 相对于 target 来定位, 返回一个 DOM 节点
  onAfterVisible: _data.noop, // 当 visible 变化时的回调函数
  onAlign: _data.noop }, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this._getContainer = function () {
    var _props3 = _this2.props;
    var getPopupContainer = _props3.getPopupContainer;
    var target = _props3.target;
    var popupClassName = _props3.popupClassName;

    var popupContainer = document.createElement('div');
    var parentNode = getPopupContainer ? getPopupContainer() : target();
    parentNode.appendChild(popupContainer);
    popupContainer.setAttribute('class', 'mt-trigger-wrapper' + (popupClassName ? ' ' + popupClassName : ''));
    return popupContainer;
  };

  this.renderSubtreeComponent = function (ready) {
    if (!_this2._container) {
      _this2._container = _this2._getContainer();
    }
    var self = _this2;
    if (_this2._container) {
      (0, _reactDom.unstable_renderSubtreeIntoContainer)(_this2, _this2.renderContentComponent(), _this2._container, function () {
        self._component = this; // 保存当前弹出框的 DOM
        if (ready) {
          ready.call(this);
        }
      });
    }
  };

  this.removePopup = function () {
    if (_this2._container) {
      var container = _this2._container;
      (0, _reactDom.unmountComponentAtNode)(container);
      container.parentNode.removeChild(container);
      _this2._container = null;
    }
  };

  this.removeContainer = function () {
    console.warn("removeContainer 将被废弃, 请使用 removePopup 来代替");
    _this2.removePopup();
  };

  this.getPopupDOMNode = function () {
    return _this2._container;
  };

  this.getTriggerDOM = function () {
    console.warn("getTriggerDOM 将被废弃, 请使用 getPopupDOMNode 来代替");
    return _this2.getPopupDOMNode();
  };

  this.forceAlign = function () {
    // 去渲染
    var props = _this2.props;
    var equalTargetWidth = props.equalTargetWidth;
    var equalTargetHeight = props.equalTargetHeight;
    var align = props.align;
    var onAlign = props.onAlign;

    var popup = (0, _reactDom.findDOMNode)(_this2._component);
    if (!popup) {
      return;
    }
    var target = props.target();
    if (!target) {
      return;
    }
    // 计算宽度/高度
    popup.style.width = equalTargetWidth ? target.getBoundingClientRect().width + 'px' : "auto";
    popup.style.height = equalTargetHeight ? target.getBoundingClientRect().height + 'px' : "auto";
    if (_this2.state.visible) {
      var source = (0, _reactDom.findDOMNode)(_this2._component);
      var res = (0, _domAlign2.default)(source, target, Object.assign({}, PLACEMENTS, align));
      var alignCls = (res.points || []).join("_");
      onAlign(source, res);
      _this2.setState({ alignCls: alignCls });
    }
  };
}, _temp);
exports.default = Trigger;